export type ThemeItem = {
  primary: string;
};

export type DefaultBreakpoints = {
  desktop?: number;
  tablet?: number;
  mobile?: number;
};

export const mainTheme: ThemeItem = {
  primary: "#f99e52",
};

export const darkTheme: ThemeItem = {
  primary: "blue",
};
export const breakpoints: DefaultBreakpoints = {
  tablet: 768,
};
